const mapPrivilegesToIds = (privileges) =>
  Object.keys(privileges)
    .map((idx) => privileges[idx])
    .filter((privilege) => privilege.active)
    .map(({ id }) => id);

export default mapPrivilegesToIds;
